import React from 'react';
import classNames from 'classnames';

/**
 * Renders a collection of circular badges with optional additional user count.
 *
 * @deprecated Use components/Avatar instead
 */
const CircleBadges = ({ data, additionalUsers, fluid }) => (
  <div className="flex items-center">
    {data.map((item, i) => (
      <div
        key={`${item._id}-${i}` || i}
        className={classNames(
          'w-12 object-cover rounded-full border-2 border-primary-300 overflow-hidden align-center justify-center flex',
          (i < data.length - 1 || additionalUsers > 0) && '-mr-3',
          !fluid && 'h-12'
        )}
      >
        <img
          alt={`${item.name}'s badge`}
          src={item.photoUrl || item.photo?.url || '/img/search/user.svg'}
        />
      </div>
    ))}
    {additionalUsers > 0 && (
      <div
        className={classNames(
          'w-12 object-cover rounded-full border-2 border-primary-300 overflow-hidden bg-white align-center justify-center flex',
          fluid ? 'self-stretch justify-self-stretch' : 'h-12'
        )}
      >
        <span>+{additionalUsers}</span>
      </div>
    )}
  </div>
);

export default CircleBadges;
